export default {
  data() {
    return {
      cn: {
        industry_area_title: "行业领域",
        industry_area: [
          {
            id: "film_television",
            title: "影视",
            description: "描述",
            image: require('@/assets/img/Homepage/IndustryArea/FilmTelevision.jpg'),
            link: { path: '/planAndCases', hash: '#film_television' }
          },
          {
            id: "digital_assets",
            title: "数字资产",
            description: "描述",
            image: require('@/assets/img/Homepage/IndustryArea/DigitalAssets.png'),
            link: { path: '/planAndCases', hash: '#digital_assets' }
          },
          {
            id: "culture_tour",
            title: "文化旅游",
            description: "描述",
            image: require('@/assets/img/Homepage/IndustryArea/CultureTour.jpg'),
            link: { path: '/planAndCases', hash: '#culture_tour' }
          },
          {
            id: "aigc",
            title: "AIGC",
            description: "描述",
            image: require('@/assets/img/Homepage/IndustryArea/AIGC.png'),
            link: { path: '/planAndCases', hash: '#aigc' }
          }
        ],

        /* ===================== PLAN AND CASES ======================*/

        plan_and_cases_title: "案例展示",
        plan_and_cases_1: [
          {
            p1: "VR Park 宁波方特场馆",
            p2: "匈牙利VR Vidámpark在中国的首个家庭娱乐度假场所，宁波方特的首个国际合作高科技主题场馆。",
            image: require('@/assets/img/Homepage/PlanandCases/OrcaBeat.jpg'),
            link: { path: '/planAndCases/cultureTour/VRParkCasesPage' }
          }
        ],
        plan_and_cases_2: [
          {
            p1: "虚拟制片：梦之海",
            p2: "太空冰川、末日废土！虚拟制片技术助力视觉盛宴！",
            // p3: "轻风感 满屋凉",
            image: require('@/assets/img/Homepage/PlanandCases/img2.jpg'),
            link: { path: '/planAndCases/filmAndTelevision/DreamWaterPage' }
          },
        ],
        plan_and_cases_345: [
          {
            p1: "北交数字博物馆",
            p2: "见证历史，感受未来! 如此不一样的博物馆体验！",
            image: require('@/assets/img/Homepage/PlanandCases/BeijiaoPictureWallOpacity.png'),
            link: { path: '/planAndCases/digitalAssets/BeijiaoDigitalMuseumPage' }
          },
          {
            p1: "象山影视城灯光投影秀",
            p2: "“唐宋奇妙夜”文化夜游活动火爆开启，旅游新体验！",
            image: require('@/assets/img/Homepage/PlanandCases/XiangshanLightingShow.png'),
            link: { path: '/planAndCases/cultureTour/CityWallProjectionPage' }
          },
          {
            p1: "数字人-MetaHuman",
            p2: "你好！我是你的新朋友，MataHuman！",
            image: require('@/assets/img/Homepage/PlanandCases/MetaHumanShangguan.jpg'),
            link: { path: '/planAndCases/AIGC/BataHumanPage' }
          }
        ],

        /* ===================== NEWS ======================*/

        news_title: "新闻资讯",
      news_1: [
        {
          p1: "云翰虹章携手匈牙利VR Vidámpark团队，共拓中国VR主题公园市场",
          // p2: "云翰虹章与匈牙利团队合作，推出VR主题公园项目",
          image: require('@/assets/img/Homepage/News/VRParkPageWallpaper_homepage_edited.png'),
          link: { path: '/news/008-VRParkPage' }
        },
      ],
      news_2: [
        {
          p1: "象山影视城“唐宋奇妙夜”文化夜游活动火爆开启，云翰虹章技术支持助力创新体验",
          // p2: "云翰虹章为“唐宋奇妙夜”的灯光投影提供了配套的技术服务",
          image: require('@/assets/img/Homepage/News/LightShowPageWallpaper_homepage_edited.png'),
          link: { path: '/news/004-LightShowPage' }
        },
        {
          p1: "中东欧青年创新创业大赛在宁波成功举办——云翰虹章团队分享创业成果",
          // p2: "云翰虹章团队在中东欧青年创新创业大赛上分享自己的创业经历",
          image: require('@/assets/img/Homepage/News/InnovationEntrepreneurshipPageWallpaper_homepage_edited.png'),
          link: { path: '/news/007-InnovationEntrepreneurshipPage' }
        },
        {
          p1: "宁波云翰虹章信息科技有限责任公司正式成立",
          // p2: "2022年6月22日成立的宁波云翰虹章致力于用技术创造独特价值。",
          image: require('@/assets/img/Homepage/News/Logo_homepage_edited.jpg'),
          link: { path: '/news/001-CompanyEstablishedPage' }
        },
      ],
      }
    };
  }
};
